import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import _, { uniqBy, sortBy } from "lodash";
import { actions } from "react-table";
import { DYNAMIC_CIRCULAR_TYPES } from "../../../types";

const INITIAL_STATE = {
  // Template operations
  addUpdateDynamicCircularReferenceTemplateResponse: [],
  addUpdateDynamicCircularReferenceTemplateLoading: true,

  // Template listing
  allCircularPlanningTemplateLoading: true,
  allCircularPlanningTemplateResp: [],

  // Company operations
  getDynamicCircularPlanningCompanyDtosResp: [],
  getDynamicCircularPlanningCompanyDtosLoading: false,
  updateCircularPlanningCompanyResp: [],
  updateCircularPlanningCompanyLoading: false,

  // Company transfer operations
  transferCompanyLoading: false,
  transferCompanyError: null,
  lastTransferredCompany: null,
};

export default function dynamicCircularReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Template operations
    case DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_TEMPLATE_INIT:
      return {
        ...state,
        addUpdateDynamicCircularReferenceTemplateResponse: [],
        addUpdateDynamicCircularReferenceTemplateLoading: true,
      };

    case DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_TEMPLATE_SUCCESS:
      return {
        ...state,
        addUpdateDynamicCircularReferenceTemplateResponse: action.payload,
        addUpdateDynamicCircularReferenceTemplateLoading: false,
        allCircularPlanningTemplateResp: sortBy(
          [...state.allCircularPlanningTemplateResp, action.payload],
          "title"
        ),
      };

    case DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_TEMPLATE_FINISH:
      return {
        ...state,
        addUpdateDynamicCircularReferenceTemplateLoading: false,
      };

    // Template listing
    case DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_TEMPLATE_INIT:
      return {
        ...state,
        allCircularPlanningTemplateLoading: true,
        allCircularPlanningTemplateResp: [],
      };

    case DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_TEMPLATE_SUCCESS:
      return {
        ...state,
        allCircularPlanningTemplateLoading: false,
        allCircularPlanningTemplateResp: sortBy(action.payload, "title"),
      };

    case DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_TEMPLATE_FINISH:
      return {
        ...state,
        allCircularPlanningTemplateLoading: false,
      };

    // Company listing
    case DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_COMPANY_TEMPLATE_INIT:
      return {
        ...state,
        getDynamicCircularPlanningCompanyDtosLoading: true,
        getDynamicCircularPlanningCompanyDtosResp: [],
      };

    case DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_COMPANY_TEMPLATE_SUCCESS:
      return {
        ...state,
        getDynamicCircularPlanningCompanyDtosLoading: false,
        getDynamicCircularPlanningCompanyDtosResp: action.payload,
      };

    case DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_COMPANY_TEMPLATE_FINISH:
      return {
        ...state,
        getDynamicCircularPlanningCompanyDtosLoading: false,
      };

    // Company update operations
    case DYNAMIC_CIRCULAR_TYPES.UPDATED_CIRCULARPLANNING_COMPANY_INIT:
      return {
        ...state,
        updateCircularPlanningCompanyResp: [],
        updateCircularPlanningCompanyLoading: true,
      };

    case DYNAMIC_CIRCULAR_TYPES.UPDATED_CIRCULARPLANNING_COMPANY_SUCCESS:
      const updatedItem = state.getDynamicCircularPlanningCompanyDtosResp
        ? state.getDynamicCircularPlanningCompanyDtosResp.reduce(
            (accumulator, item) => {
              if (item.id === action.payload.id) {
                if (action.payload.isactive) {
                  return [...accumulator, action.payload];
                } else {
                  return accumulator;
                }
              } else {
                return [...accumulator, item];
              }
            },
            []
          )
        : [];

      if (
        !state.getDynamicCircularPlanningCompanyDtosResp ||
        !state.getDynamicCircularPlanningCompanyDtosResp.some(
          (item) => item.id === action.payload.id
        )
      ) {
        updatedItem.push(action.payload);
      }

      return {
        ...state,
        updateCircularPlanningCompanyResp: action.payload,
        updateCircularPlanningCompanyLoading: false,
        getDynamicCircularPlanningCompanyDtosResp: updatedItem,
      };

    case DYNAMIC_CIRCULAR_TYPES.UPDATED_CIRCULARPLANNING_COMPANY_FINISH:
      return {
        ...state,
        updateCircularPlanningCompanyLoading: false,
      };

    // Company transfer operations
    case DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_COMPANY_FROM_LIST_INIT:
      return {
        ...state,
        transferCompanyLoading: true,
        transferCompanyError: null,
      };

    case DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_COMPANY_FROM_LIST_SUCCESS:
      const newCompany = action.payload;

      // Check if company already exists
      const existingCompanyIndex =
        state.getDynamicCircularPlanningCompanyDtosResp?.findIndex(
          (company) => company.companyId === newCompany.companyId
        ) ?? -1;

      let updatedCompanies;
      if (existingCompanyIndex !== -1) {
        // Update existing company
        updatedCompanies = [...state.getDynamicCircularPlanningCompanyDtosResp];
        updatedCompanies[existingCompanyIndex] = {
          ...updatedCompanies[existingCompanyIndex],
          ...newCompany,
          isActive: true,
        };
      } else {
        // Add new company
        updatedCompanies = [
          ...(state.getDynamicCircularPlanningCompanyDtosResp || []),
          newCompany,
        ];
      }

      return {
        ...state,
        transferCompanyLoading: false,
        lastTransferredCompany: newCompany,
        getDynamicCircularPlanningCompanyDtosResp: updatedCompanies,
      };

    case DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_COMPANY_FROM_LIST_FINISH:
      return {
        ...state,
        transferCompanyLoading: false,
      };

    case DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_COMPANY_FROM_LIST_FAILURE:
      return {
        ...state,
        transferCompanyLoading: false,
        transferCompanyError: action.payload,
      };

    default:
      return state;
  }
}
